export default __webpack_public_path__ + "static/media/Osmosis.4cf4016f.png";